import { Command } from '@/plugins/cad/module/core/Command'
import type { CADViewManager } from '../manager/CADViewManager'
import type { IEntity } from '../model/entity'

/**
 * 打断实体命令，以新生成片段替换原实体，支持撤销/重做。
 */
export class BreakEntityCommand extends Command {
  constructor(
    private readonly originalEntities: IEntity[],
    private readonly createdEntities: IEntity[],
    private readonly viewManager: CADViewManager
  ) {
    super()
  }

  /** 移除原实体并加入新生成的片段 */
  execute(): void {
    this.viewManager.addEntities(this.createdEntities)
    this.viewManager.deleteEntities(this.originalEntities)
  }

  /** 撤销：还原原实体并移除新片段 */
  undo(): void {
    this.viewManager.deleteEntities(this.createdEntities)
    this.viewManager.addEntities(this.originalEntities)
  }

  /** 重做：重新执行打断 */
  redo(): void {
    this.execute()
  }
}
